import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Vaše Firebase konfigurace
const firebaseConfig = {
  apiKey: "AIzaSyBtgtw2hUK778keHF-2uIVkS0qzARwu1pA",
  authDomain: "kavarnaapi.firebaseapp.com",
  projectId: "kavarnaapi",
  storageBucket: "kavarnaapi.firebasestorage.app",
  messagingSenderId: "220398252082",
  appId: "1:220398252082:web:a7348125c2d71af6cdcc2b",
  measurementId: "G-Q9JW8RNZDF",
};

// Inicializace Firebase
const app = initializeApp(firebaseConfig);

// Inicializace služeb
const db = getFirestore(app);
const auth = getAuth(app);

export { app, db, auth };
